import { render } from "./01_OptimaleRaumaufteilung.vue?vue&type=template&id=7c3db23d"
import script from "./01_OptimaleRaumaufteilung.vue?vue&type=script&lang=js"
export * from "./01_OptimaleRaumaufteilung.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__